"use client"
/* */
const locales = {"de-DE": {  "searchField.search": `Suche`,
},"en-US": {  "searchField.search": `Search`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@e940efc6da10fdf09417eb079b65a343.mjs.map
